import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Routes, RouterModule } from '@angular/router';

import { AdminMsgComponent } from "./admin-msg.component";


const routes: Routes = [
  {
    path: 'admin-msg',
    component: AdminMsgComponent,
  },
];

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
  ],
})
export class AdminMsgRoutingModule {}
